function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.54673 1.87679C9.00741 -0.216804 11.9926 -0.216809 12.4533 1.87679L13.5502 6.86186C13.7277 7.66833 14.3825 8.28282 15.1986 8.40869L19.1841 9.02337C21.4443 9.37197 21.4443 12.628 19.1841 12.9766L15.1986 13.5913C14.3825 13.7172 13.7277 14.3317 13.5502 15.1381L12.4533 20.1232C11.9926 22.2168 9.00741 22.2168 8.54673 20.1232L7.4498 15.1381C7.27234 14.3317 6.6175 13.7172 5.80139 13.5913L1.81594 12.9766C-0.444252 12.628 -0.444251 9.37197 1.81594 9.02337L5.80139 8.40869C6.6175 8.28282 7.27234 7.66833 7.4498 6.86186L8.54673 1.87679Z",
  fill: "white"
});

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.95b044c7.svg";
export { ForwardRef as ReactComponent };